import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';
import {map, tap, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http: HttpClient;
  private tempAccessToken: string | null = null;
  private tempRefreshToken: string | null = null;
  private tempUser: any = null;
  private baseUrl = environment.baseUrl;
  private logoutInProgress = false;

  constructor(http: HttpClient, private router: Router) {
    this.http = http;
  }


  // Called on login
  storeTempLogin(accessToken: string, refToken:string, user: any) {
    this.tempAccessToken = accessToken;
    this.tempRefreshToken = refToken;
    this.tempUser = user;
  }

  // getTempToken() {
  //   return this.tempAccessToken;
  // }

  // getTempUser() {
  //   return this.tempUser;
  // }

  saveToLocalStorage() {
    if (this.tempAccessToken && this.tempRefreshToken && this.tempUser) {
      localStorage.setItem('accessToken', this.tempAccessToken);
      localStorage.setItem('refreshToken', this.tempRefreshToken);
      localStorage.setItem('user', JSON.stringify(this.tempUser));
    }
    this.clearTemp(); // optional
  }

    updateStoredUser(updates: Record<string, unknown>) {
        const storedUser = localStorage.getItem('user');
        if (!storedUser) {
            return;
        }
        const userObj = JSON.parse(storedUser);
        localStorage.setItem('user', JSON.stringify({...userObj, ...updates}));
    }

  clearTemp() {
    this.tempAccessToken = null;
    this.tempRefreshToken = null;
    this.tempUser = null;
  }

  getToken() {
    return this.tempAccessToken || localStorage.getItem("accessToken");
  }

  getCurrentUserInfo(){
    let user = localStorage.getItem('user') ||  JSON.stringify(this.tempUser);
    if (user){
      const userObj = JSON.parse(user);
      const groups = Array.isArray(userObj['groups']) ? userObj['groups'] : [userObj['groups']].filter(Boolean);
      return {
              'id': userObj['id'],
              'role': userObj['groups'],
          'is_superuser': userObj['is_superuser'] === true,
              'orgId': userObj['org_id'],
              'subscription_enabled': userObj['subscription_enabled'],
              'visitor_management_enabled': userObj['visitor_management_enabled'],
              'lastName': userObj['last_name'],
              'firstName': userObj['first_name'],
              'camera_esn': userObj['camera_esn'],
              'is_mobile_verified': userObj['is_mobile_verified'] || false,
            };
    }
    return {
      'id': '',
      'role': '',
      'is_superuser': false,
      'orgId': '',
      'subscription_enabled': undefined,
      'visitor_management_enabled': undefined,
      'lastName': '',
      'firstName': '',
      'camera_esn':'',
      'is_mobile_verified': false
    };
  }

  isSuperUser(): boolean {
    return this.getCurrentUserInfo()?.is_superuser === true;
  }

  isAuthenticated(): Boolean {
    return this.hasValidAccessToken();
  }

   getRefreshToken(): string | null {
    return this.tempRefreshToken || localStorage.getItem("refreshToken");
  }

  refreshToken() {
    const refreshToken = this.getRefreshToken();

    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available'));
    }

    return this.http.post<any>(`${this.baseUrl}token/refresh/`, { refresh: refreshToken }).pipe(
      tap(response => {
        // Save new tokens
        if (response?.access) {
          this.tempAccessToken = response.access;
          localStorage.setItem('accessToken', response.access);
        }
        if (response?.refresh) {
          this.tempRefreshToken = response.refresh;
          localStorage.setItem('refreshToken', response.refresh);
        }
      }),
      map(response => response.access)
    );
  }


  clearSession() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('activeLink');
    this.clearTemp();
  }

  hasValidAccessToken(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1] || ''));
      const expiresAt = Number(payload?.exp);
      if (!Number.isFinite(expiresAt)) {
        return false;
      }
      return expiresAt > Math.floor(Date.now() / 1000);
    } catch {
      return false;
    }
  }

  logout() {
    if (this.logoutInProgress) {
      return;
    }

    this.logoutInProgress = true;
    this.clearSession();

    if (this.router.url === '/login') {
      this.logoutInProgress = false;
      return;
    }

    void this.router.navigate(['/login']).finally(() => {
      this.logoutInProgress = false;
    });
  }

  // logout() {
  //   localStorage.removeItem('accessToken');
  //   localStorage.removeItem('refreshToken');
  //   // Navigate to login page
  //   window.location.href = '/login';
  // }
}
